import axios from "axios";

// Entrega de leads: lead-relay (Cloudflare Worker) → backend FastAPI → sin entrega.
// Nunca se almacena PII en el navegador.
export async function submitLead(data, source = "landing-react") {
  const LEAD_ENDPOINT = process.env.REACT_APP_LEAD_ENDPOINT;
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  if (LEAD_ENDPOINT) {
    try {
      const res = await axios.post(LEAD_ENDPOINT, { ...data, source }, { timeout: 10000 });
      if (res.data && res.data.ok) return { delivered: true, method: "lead-relay" };
    } catch (e) {
      // continuar al siguiente canal
    }
  }

  if (BACKEND_URL) {
    try {
      const res = await axios.post(`${BACKEND_URL}/api/contact`, data, { timeout: 10000 });
      if (res.status === 200 || res.status === 201) return { delivered: true, method: "backend" };
    } catch (e) {
      // sin canal disponible
    }
  }

  return { delivered: false, method: null };
}
